import React from "react";

const TopHeader = () => {
    return (
        <div id="topnavbar"
             style={{width: "100%", height: "25px", borderBottom: "1px solid  #E6E6E6"}}>
            <div id="bar">
                <div id="container">
                    <table width="100%" border="0">
                        <tbody>
                        <tr>
                            <td><strong>Xổ Số Minh Ngọc™ » XSMN » Kết quả xổ số trực tiếp » Đổi Số Trúng » www.minhngocc</strong></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};
export default TopHeader
